// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isAppsUploadMessageResult = objectOf({
  images: objectOf({
    uploaded_images: arrayOf(
      objectOf({
        path: string,
        name: string,
        id: string,
        size: number,
      })
    ),
    fail_to_upload_images: arrayOf(
      objectOf({
        name: string,
      })
    ),
    missing_images: arrayOf(
      objectOf({
        name: string,
      })
    ),
    not_used_images: arrayOf(
      objectOf({
        name: string,
      })
    ),
  }),
  other_assets: arrayOf(nullOrUndefined),
  template_name: string,
  number_of_replaced_image_paths: number,
  body_content: string,
});
